import { Config } from '../../entidades/entidades';


export default class Utils {

    constructor() { }

    static dateOnlyStr(dt: string) {
        const d: Date = new Date(dt);
        const mm = d.getMonth() + 1;
        const dd = d.getDate();

        return [
            (dd > 9 ? "" : "0") + dd,
            (mm > 9 ? "" : "0") + mm,
            d.getFullYear()
        ].join("-");
    }

    static isEmpty(data) {
        if (typeof data === "object") {
            if (JSON.stringify(data) === "{}" || JSON.stringify(data) === "[]") {
                return true;
            } else if (!data) {
                return true;
            }
            return false;
        } else if (typeof data === "string") {
            if (!data.trim()) {
                return true;
            }
            return false;
        } else if (typeof data === "undefined") {
            return true;
        } else {
            return false;
        }
    };

    static getBaseUrlApiWeb() {

        let config: Config = JSON.parse(localStorage.getItem("config"));
        if (!config) return "";

        let baseUrlApiWeb;
        baseUrlApiWeb = config.urlAPI;
        return baseUrlApiWeb;
    };

    static getBaseUrlCartoWeb() {

        let config: Config = JSON.parse(localStorage.getItem("config"));
        if (!config) return "";

        let baseUrlCartoWeb;
        baseUrlCartoWeb = config.urlCarto;
        return baseUrlCartoWeb;
    };
}

export function formatDateForBackend(date: Date): Date {
    return new Date(`${date}T00:00:00`);
}